<div class="h-100 d-flex justify-content-center align-items-center overflow-visible">
  <div class="vehicle-transmission-status" style="background-color:{{nameColor}};" title="{{tooltipText}}" data-bs-toggle="tooltip" data-bs-placement="top" container="body"></div>

</div>